import { GetMicrostoreColumnTemplatesQuery } from 'data/__generated__';
import { GET_MICROSTORE_COLUMN_TEMPLATES_QUERY } from 'data/queries/microstoreColumnTemplate';
import { apolloClient } from '../../../App';

export const deletedMicrostoreColumnTemplatesHandler = (deletedMicrostoreColumnTemplateIds: string[]) => {
    let currentMicrostoreColumnTemplates = [] as GetMicrostoreColumnTemplatesQuery['microstoreColumnTemplatesQuery'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetMicrostoreColumnTemplatesQuery>({
            query: GET_MICROSTORE_COLUMN_TEMPLATES_QUERY,
        });
        if (!result) {
            throw Error('An error occurred when reading GET_MICROSTORE_COLUMN_TEMPLATES_QUERY');
        }
        currentMicrostoreColumnTemplates = result.microstoreColumnTemplatesQuery;
    } catch {
        // do nothing
    }

    const newMicrostoreColumnTemplates = currentMicrostoreColumnTemplates.filter(
        (microstoreColumnTemplate) => !deletedMicrostoreColumnTemplateIds.includes(microstoreColumnTemplate._id),
    );

    apolloClient.writeQuery({
        query: GET_MICROSTORE_COLUMN_TEMPLATES_QUERY,
        data: { microstoreColumnTemplatesQuery: newMicrostoreColumnTemplates },
    });
};

export const microstoreColumnTemplatesUpdatedOrCreatedHandler = (
    microstoreColumnTemplatesUpdatedOrCreated: GetMicrostoreColumnTemplatesQuery['microstoreColumnTemplatesQuery'],
) => {
    let currentMicrostoreColumnTemplates = [] as GetMicrostoreColumnTemplatesQuery['microstoreColumnTemplatesQuery'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetMicrostoreColumnTemplatesQuery>({
            query: GET_MICROSTORE_COLUMN_TEMPLATES_QUERY,
        });
        if (!result) {
            throw Error('An error occurred when reading GET_MICROSTORE_COLUMN_TEMPLATES_QUERY');
        }
        currentMicrostoreColumnTemplates = result.microstoreColumnTemplatesQuery;
    } catch {
        // do nothing
    }

    const updatedOrCreatedMicrostoreColumnTemplateIds = microstoreColumnTemplatesUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedMicrostoreColumnTemplates = currentMicrostoreColumnTemplates.filter(
        ({ _id }) => !updatedOrCreatedMicrostoreColumnTemplateIds.includes(_id),
    );
    const newMicrostoreColumnTemplates = [
        ...microstoreColumnTemplatesUpdatedOrCreated,
        ...nonUpdatedOrCreatedMicrostoreColumnTemplates,
    ];

    apolloClient.writeQuery({
        query: GET_MICROSTORE_COLUMN_TEMPLATES_QUERY,
        data: { microstoreColumnTemplatesQuery: newMicrostoreColumnTemplates },
    });
};
